import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { InfoItemTypes } from '../../../chords/info-panel/info-panel.model';
import { BREAKPOINTS } from '../../../shared/constants';
import { WindowService } from '../../../shared/services/window.service';
import { ClaimsInstructions } from '../claim-submission.model';

@Component({
  selector: 'zip-claim-submission-instructions',
  templateUrl: './claim-submission-instructions.component.html',
  styleUrls: ['./claim-submission-instructions.component.scss'],
})
export class ClaimSubmissionInstructionsComponent {
  @Input() config: ClaimsInstructions;
  @Output() cancelInstructions = new EventEmitter<void>();
  @Output() confirmInstructions = new EventEmitter<void>();
  types = InfoItemTypes;
  isMobileView = false;
  constructor(private window: WindowService) {}

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = this.window.nativeWindow.innerWidth < BREAKPOINTS.SMALL;
  }

  public cancel(): void {
    this.cancelInstructions.emit();
  }

  public continue(): void {
    this.confirmInstructions.emit();
  }
}
